(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationDeleteController',HospitalizationDeleteController);

    HospitalizationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Hospitalization'];

    function HospitalizationDeleteController($uibModalInstance, entity, Hospitalization) {
        var vm = this;
        vm.hospitalization = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Hospitalization.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
